import { render, staticRenderFns } from "./optSection.vue?vue&type=template&id=2350c4ba&scoped=true"
import script from "./optSection.vue?vue&type=script&lang=js"
export * from "./optSection.vue?vue&type=script&lang=js"
import style0 from "./optSection.vue?vue&type=style&index=0&id=2350c4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350c4ba",
  null
  
)

export default component.exports